// Match IPv4 address with an optional port number
const WEBHOOK_URL_IPV4_REGEX = new RegExp(
  /^(https?:\/\/)?(\b25[0-5]|\b2[0-4][0-9]|\b[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}.*$/
);
// Match localhost address with an optional port number
const WEBHOOK_URL_LOCALHOST_REGEX = new RegExp(/^(https?:\/\/)?localhost.*$/);

export function isIPv4Address(url: string): boolean {
  return WEBHOOK_URL_IPV4_REGEX.test(url);
}

export function isLocalhostAddress(url: string): boolean {
  return WEBHOOK_URL_LOCALHOST_REGEX.test(url);
}

export function isValidURLFormat(url: string): boolean {
  try {
    new URL(url);
  } catch (e) {
    return false;
  }
  return true;
}
